import styled from 'styled-components';
import media from '../../../styles/Media.styled';

export const BackdropStyle = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: ${(props) =>
        props.loaderBackground ? '#00000099' : 'rgb(47, 45, 70, 0.83)'};
    z-index: 99999;
    display: ${(props) => (props.show ? 'block' : 'none')};
`;

export const CloseButton = styled.div`
    margin: 1.5rem 1.5rem;
    float: right;
    right: 0;
    width: 1.5rem;
    height: 1.5rem;
    display: ${(props) => (props.isModal ? 'none' : 'block')};
    ${media.portraitDevice`
        display: ${(props) => (props.isModal ? 'none' : 'block')};
        margin: 1.2rem 2.2rem;
        width: 2rem;
        height: 1rem;
    `}
`;

export const ButtonContainer = styled.div`
    position: absolute;
    height: 44px;
`;

export const CloseIconImage = styled.img`
  width: 1.38rem;
  height: auto;
  margin: 50px 8px 8px;
`;